import {pathHelpContentFile} from '../../../utils/path';
import {CONTENT_CATEGORY_OPTION, CONTENT_TYPE_INTERNAL_LINK, CONTENT_TYPE_TEXT} from '../../constants';

export default {
  id: 'MOD_MAND_COLL',
  title: 'Che cos\'è il mandato di diffusione e come attivarlo?',
  description: '',
  categories: [CONTENT_CATEGORY_OPTION],
  contents: [{
    type: CONTENT_TYPE_TEXT,
    value: 'Di che si tratta?'
  },
  {
    type: CONTENT_TYPE_TEXT,
    value: 'Il mandato di diffusione consente di semplificare la distribuzione dei documenti amministrativi su piattaforme non aderenti allo standard OPERA. Risparmia tempo chiedendo a OnceForAll di farlo per te.'
  },
  {
    type: CONTENT_TYPE_TEXT,
    value: 'Come si procede ?'
  },
  {
    type: CONTENT_TYPE_TEXT,
    adornment: '1.',
    value: 'Scarica il documento'
  },
  {
    type: CONTENT_TYPE_INTERNAL_LINK,
    value: `${pathHelpContentFile}it/IT_MOD_MAND_COLL/Mandat de Collecte.pdf`,
    label: 'cliccando qui'
  },
  {
    type: CONTENT_TYPE_TEXT,
    adornment: '2.',
    value: 'Restituisci il documento compilato e firmato a servizio.clienti@onceforall.com'
  }]
};
